import { createRouter, createWebHashHistory } from "vue-router";

const routes = [
  {
    path: "/",
    name: "Home",
    component: () => import("../views/HomeView.vue"),
  },
  {
    path: "/about-movolonter",
    name: "about-movolonter",
    component: () => import("../views/HomeView.vue"),
  },
  {
    path: "/user-groups",
    name: "user-groups",
    component: () => import("../views/HomeView.vue"),
  },
  {
    path: "/become-a-volunteer",
    name: "become-a-volunteer",
    component: () => import("../views/HomeView.vue"),
  },
  {
    path: "/our-categories",
    name: "our-categories",
    component: () => import("../views/HomeView.vue"),
  },
  {
    path: "/our-partners",
    name: "our-partners",
    component: () => import("../views/HomeView.vue"),
  },
  {
    path: "/privacypolicy",
    name: "privacypolicy",
    component: () => import("../views/PrivacyPolicyView.vue"),
  },
  {
    path: "/userprofile/:id",
    name: "userprofile",
    component: () =>
      import("../components/UserProfile/views/userDashboardView.vue"),
  },
  {
    path: "/event/:id",
    name: "eventProfile",
    component: () => import("../views/EventView.vue"),
  },
  {
    path: "/faq",
    name: "faqs",
    component: () => import("../views/faqsView.vue"),
  },
  {
    path: "/newsfeeds",
    name: "newsfeeds",
    component: () => import("../views/NewsfeedView.vue"),
  },
  {
    path: "/allNewsfeeds",
    name: "newsfeeds",
    component: () =>
      import("../components/NewsFeed/views/NewsfeedListView.vue"),
  },
  {
    path: "/newsfeed/:id",
    name: "specificNewsfeed",
    component: () => import("../components/NewsFeed/views/NewsfeedView.vue"),
  },
  {
    path: "/allActivities",
    name: "activities",
    component: () => import("../components/Activities/AllActivitiesView.vue"),
  },
  {
    path: "/ngos",
    name: "ngos",
    component: () => import("../components/NGOs/AllNGOs.vue"),
  },
  {
    path: "/ngoProfile/:id",
    name: "ngoProfile",
    component: () => import("../components/NGOs/NGOProfile.vue"),
  },
  {
    path: "/userNotFound",
    name: "userNotFound",
    component: () => import("../views/userNotFoundView.vue"),
  },
  {
    path: "/contact",
    name: "contact",
    component: () => import("../views/contactView.vue"),
  },
  {
    path: "/:catchAll(.*)",
    name: "404NotFound",
    component: () => import("../views/notFoundView.vue"),
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

// function checkValidity(to, from, next) {
//   var token = storageService.GetSession("token");

//   if (to.meta.requiresToken == "LoginToken") {
//     if (token) {
//       next();
//     } else {
//       next("/login");
//     }
//   } else {
//     next();
//   }
// }

//router.beforeEach((to, from, next) => checkValidity(to, from, next));

export default router;
